export default "__VITE_ASSET__Bp7Z0YBG__"